import type { HTMLAttributes } from "react"
import { cn } from "@/lib/utils"

/**
 * A card (refined-system §5.2): white, a hairline border, radius 6, no shadow. Only for something to judge, act on or
 * open. `data-card` keeps the chat column's reading size off its body (styles.css, `.chat-thread`).
 */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-card=""
      className={cn("rounded-card border border-rule bg-surface p-4 max-sm:p-3.5", className)}
      {...props}
    />
  )
}

/** Card kind label; cobalt only when the card needs the viewer. */
export function CardKicker({
  needs = false,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { needs?: boolean }) {
  return <span className={cn("kicker block", needs && "text-needs", className)} {...props} />
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn("type-card", className)} {...props} />
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("type-ui mt-1 max-w-[560px] text-ink-2", className)} {...props} />
}
